import { useGlobalState, useStatsigLayer } from '@/hooks';
import { useMyParcelsContext } from '@/modules/pmt/context';

export const useShipmentSearchCopy = () => {
  const { isLoggedIn } = useGlobalState();
  const { mainTranslation } = useMyParcelsContext();
  const { get: getAnonymous, isReady: isAnonymousReady } = useStatsigLayer('track_my_parcel_copy_layer');
  const { get: getSignedIn, isReady: isSignedInReady } = useStatsigLayer('track_my_parcel_signed_in_layer');

  const fallback = {
    sectionTitleDesktop: mainTranslation.parcelListSectionTitleDesktop ?? '',
  };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const get = isLoggedIn ? getSignedIn : getAnonymous;

  return {
    sectionTitleDesktop: get('section_title_desktop', fallback.sectionTitleDesktop),
  };
};
